import { render } from "./JointSurveyComponent.vue?vue&type=template&id=04744823"
import script from "./JointSurveyComponent.vue?vue&type=script&lang=js"
export * from "./JointSurveyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__